import { render, staticRenderFns } from "./ServiceSettings.vue?vue&type=template&id=bb2005b6&scoped=true&lang=pug&"
import script from "./ServiceSettings.vue?vue&type=script&lang=js&"
export * from "./ServiceSettings.vue?vue&type=script&lang=js&"
import style0 from "./ServiceSettings.vue?vue&type=style&index=0&id=bb2005b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb2005b6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCol,VExpandTransition,VRadio,VRadioGroup,VRow,VSelect,VTextField})
